// AddAsset.js
import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Card, Alert } from "react-bootstrap";
import axios from "axios";
import "./AddAssest.css";
import TopNavbar from "../../Components/Navbar/Navbar";

const AddAsset = () => {
  const [form, setForm] = useState({
    asset_type: "",
    quantity: "",
    condition: "",
    purchase_year: "",
    asset_value: "",
    remarks: "",
  });

  // 👇 NEW: session user bits
  const [userMeta, setUserMeta] = useState({ username: "", Areaoffice: "" });

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("user2");
      if (raw) {
        const u = JSON.parse(raw);
        setUserMeta({
          username: u?.username || "",
          Areaoffice: u?.Areaoffice || "",
        });
      }
    } catch (e) {
      console.error("Failed to parse session user2:", e);
    }
  }, []);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");

  const assetTypes = [
  // 🖥 IT & Computer Assets
  "Desktop Computer",
  "Laptop",
  "Monitor",
  "Keyboard",
  "Mouse",
  "Headphones / Earphones",
  "Web Camera",
  "Laptop Charger",
  "Computer UPS",
  "Docking Station",
  "External Hard Drive",
  "Pen Drive",
  "Laser Printer",
  "Inkjet Printer",
  "All-in-One Printer/Scanner",
  "Scanner",
  "Barcode Scanner",
  "Router",
  "WiFi Access Point",
  "LAN Switch",
  "LAN Cable",
  "Network Rack",
  "Biometric Attendance Machine",

  // 📱 Mobile & Communication
  "Mobile Phone",
  "Tablet",
  "SIM Card (Postpaid)",
  "SIM Card (Prepaid)",
  "Power Bank",
  "Hotspot Dongle",
  "Bluetooth Device",
  "Bluetooth Headset",
  "Mobile Charger",

  // 🪑 Furniture
  "Chair",
  "Table",
  "Desk",
  "Storage Cupboard",
  "Almirah",
  "Display Rack",
  "Notice Board",
  "Whiteboard",
  // ⚡ Electrical & Electronics
  "Ceiling Fan",
  "Table Fan",
  "Pedestal Fan",
  "Air Conditioner - Split",
  "Air Conditioner - Window",
  "Refrigerator",
  "Water Dispenser",
  "Microwave Oven",
  "Electric Kettle",
  "Inverter",
  "Inverter Battery",
  "Stabilizer",
  "Extension Board",
  "Spike Guard",
  "LED Tube Light",
  "LED Panel Light",
  "LED Bulb",

  // 🧾 Office Equipment
  "Projector",
  "Projector Screen",
  "Laminator",
  "Calculator",
  "POS Machine",
  "CCTV Camera",
  "DVR/NVR",
  "LED TV",
  "Speakers",
  "Label Printer",

  // 🛡 Security & Safety
  "Fire Extinguisher",
  "First Aid Kit",
  "Biometric Door Lock",

  // ☕ Pantry & Misc
  "Tea/Coffee Machine",
  "Water Bottle",
  "Water Jug",
  "Glass Set",
  "Cup Set",
  "Dustbin",
  "Cleaning Kit",
  "Umbrella",
  "Tool Kit",
  "Ladder",
];


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const showNotification = (message, type = "success") => {
    setAlertMessage(message);
    setAlertType(type);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 👇 include username + Areaoffice
      const payload = {
        ...form,
        username: userMeta.username,
        Areaoffice: userMeta.Areaoffice,
      };
      await axios.post("https://api.assetview.warrantyindia.com/api/assets", payload);
      showNotification("✅ Asset record added successfully!");
      setForm({
        asset_type: "",
        quantity: "",
        condition: "",
        purchase_year: "",
        remarks: "",
      });
    } catch (err) {
      console.error(err);
      showNotification("❌ Failed to save data. Please try again.", "danger");
    }
  };

  return (
    <>
      <TopNavbar />
      <div className="addasset-page" style={{ width: "100vw", marginTop: "350px" }}>
        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col xl={10} lg={10} md={12} sm={12}>
              {showAlert && (
                <Alert variant={alertType} className="mb-4 alert-fade-in" dismissible onClose={() => setShowAlert(false)}>
                  {alertMessage}
                </Alert>
              )}

              <Card className="asset-card shadow-lg border-0">
                <Card.Header className="asset-card-header py-4">
                  <div className="d-flex align-items-center">
                    <div className="header-icon me-3"><i className="fas fa-building"></i></div>
                    <div>
                      <h1 className="page-title mb-1">Asset Entry Form</h1>
                      <p className="page-subtitle mb-0">Add new assets to the inventory management system</p>
                    </div>
                  </div>
                </Card.Header>

                <Card.Body className="p-5">
                  <Form onSubmit={handleSubmit} className="asset-form">
                    {/* (Optional) show user + areaoffice as read-only */}
                    {/* hide this row when you don't want it visible */}
{false && (
  <Row className="mb-4">
    <Col lg={4} md={4} className="mb-3">
      <Form.Group>
        <Form.Label className="form-label">
          <i className="fas fa-user me-2"></i> Username
        </Form.Label>
        <Form.Control
          readOnly
          value={userMeta.username}
          className="form-control-professional"
        />
      </Form.Group>
    </Col>

    <Col lg={4} md={4} className="mb-3">
      <Form.Group>
        <Form.Label className="form-label">
          <i className="fas fa-map-marker-alt me-2"></i> Area Office
        </Form.Label>
        <Form.Control
          readOnly
          value={userMeta.Areaoffice}
          className="form-control-professional"
        />
      </Form.Group>
    </Col>
  </Row>
)}


                    {/* Row 1 */}
                    <Row className="mb-4">
                      <Col lg={4} md={4} className="mb-3">
                        <Form.Group>
                          <Form.Label className="form-label"><i className="fas fa-cube me-2"></i>Asset Type</Form.Label>
                          <Form.Select
  name="asset_type"
  value={form.asset_type}
  onChange={handleChange}
  className="form-control-professional"
  required
>
  <option value="">Select Asset Type</option>
  {assetTypes.map((a) => (
    <option key={a} value={a}>{a}</option>
  ))}
</Form.Select>

                        </Form.Group>
                      </Col>

                      <Col lg={4} md={4} className="mb-3">
                        <Form.Group>
                          <Form.Label className="form-label"><i className="fas fa-hashtag me-2"></i>Quantity</Form.Label>
                          <Form.Control type="number" name="quantity" min="1" value={form.quantity} onChange={handleChange} placeholder="Enter quantity" className="form-control-professional" required />
                        </Form.Group>
                      </Col>

                      <Col lg={4} md={4} className="mb-3">
                        <Form.Group>
                          <Form.Label className="form-label"><i className="fas fa-clipboard-check me-2"></i>Condition</Form.Label>
                          <Form.Select name="condition" value={form.condition} onChange={handleChange} className="form-control-professional">
                            <option value="">Select Condition</option>
                            <option value="Excellent">Excellent</option>
                            <option value="Good">Good</option>
                            <option value="Fair">Fair</option>
                            <option value="Poor">Poor</option>
                            <option value="Damaged">Damaged</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Row 2 */}
                    <Row className="mb-4">
                      <Col lg={4} md={4} className="mb-3">
                        <Form.Group>
                          <Form.Label className="form-label"><i className="fas fa-calendar-alt me-2"></i>Recieved Year</Form.Label>
                          <Form.Control type="number" name="purchase_year" min="2000" max={new Date().getFullYear()} value={form.purchase_year} onChange={handleChange} placeholder="Enter purchase year" className="form-control-professional" />
                        </Form.Group>
                      </Col>

                      <Col lg={4} md={4} className="mb-3">
  <Form.Group>
    <Form.Label className="form-label">
      Asset Value (₹)
    </Form.Label>
    <Form.Control
      type="number"
      name="asset_value"
      value={form.asset_value}
      onChange={handleChange}
      placeholder="Enter asset value"
      min="0"
      step="0.01"
      required
      className="form-control-professional"
    />
    <Form.Text className="text-muted">
      Numeric value only (example: 25000 or 12500.50)
    </Form.Text>
  </Form.Group>
</Col>

                    </Row>

                    <Row className="mb-4">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="form-label"><i className="fas fa-sticky-note me-2"></i>Remarks</Form.Label>
                          <Form.Control as="textarea" rows={4} name="remarks" value={form.remarks} onChange={handleChange} placeholder="Enter any additional details, notes, or special instructions..." className="form-control-professional" />
                          <Form.Text className="text-muted">Optional: Add any relevant information about the asset.</Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Submit */}
                    <Row className="mt-5">
                      <Col md={12}>
                        <div className="d-flex justify-content-end gap-3">
                          <Button variant="outline-secondary" className="btn-cancel px-4 py-2"
                            onClick={() =>
                              setForm({
                                asset_type: "",
                                quantity: "",
                                condition: "",
                                purchase_year: "",
                                remarks: "",
                              })
                            }>
                            <i className="fas fa-times me-2"></i>Clear Form
                          </Button>
                          <Button type="submit" className="btn-save px-5 py-2">
                            <i className="fas fa-save me-2"></i>Save Asset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AddAsset;
